export default "__VITE_ASSET__Br2a7UC1__"